export default __webpack_public_path__ + "static/media/levels.0a51e50e.svg";